module.exports = __webpack_public_path__ + "img/p3.ba17bb9f.jpg";